<script setup>
import { ref, reactive, computed } from "vue";
import { apiQuery } from "@/api/j24api";
// import { Auth } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

const creds = reactive({
  intunetenantid: "",
  intuneclientid: "",
  intunesecret: "",
});

const loadingButton = ref(false);
const showCompletionDialog = ref(false);

var buttonColor = ref("darkgrey");
var buttonText = ref("Request Report");

async function verifyCredentialsButton(credentials) {
  loadingButton.value = true;

  const result = await apiQuery("ELA", "mdmTools/command", {
    mdm: "intune",
    command: "credentialsCheck",
    creds: {
      intuneTenantId: creds.intunetenantid,
      intuneClientId: creds.intuneclientid,
      intuneSecret: creds.intunesecret,
    },
  });

  if (result == "Success") {
    buttonColor.value = "green";
    buttonText.value = "Report Requested";

    apiQuery("ELA", "mdmTools/command", {
      mdm: "intune",
      command: "securityAudit",
      creds: {
        intuneTenantId: creds.intunetenantid,
        intuneClientId: creds.intuneclientid,
        intuneSecret: creds.intunesecret,
      },
      email: await getPortalUser(),
    });

    sendLog();
    completionDialogBox(true);
  } else {
    buttonColor.value = "red";
    buttonText.value = "Invalid Credentials";
  }

  loadingButton.value = false;
}

function completionDialogBox(status) {
  if (status == true) {
    showCompletionDialog.value = true;
  } else {
    showCompletionDialog.value = false;
  }
}

async function getPortalUser() {
  // Get the ELA authenticated user's email address.
  const currentAuthenticatedUser = await fetchAuthSession();
  if (currentAuthenticatedUser) {
    var email = currentAuthenticatedUser.tokens.idToken.payload.email;
  }

  return email;
}

async function sendLog() {
  var portalUser = await getPortalUser();

  const logObject = {
    mdm: "Intune",
    logType: "SecurityAudit",
    intuneTenantId: creds.intunetenantid,
    intuneClientId: creds.intuneclientid,
    portalUser: portalUser,
    timestamp: new Date().toISOString(),
    log: "Security Audit Requested",
  };

  await apiQuery("ELA", "mdmTools/command", {
    mdm: "intune",
    command: "log",
    payload: logObject,
  });
}
</script>

<template>
  <v-sheet>
    <v-card-text>
      <v-card max-width="500" variant="elevated" class="mx-auto">
        <v-card-text>
          <v-table class="text-left">
            <v-responsive class="mx-auto py-2" max-width="500">
              <v-text-field
                clearable
                v-model="creds.intunetenantid"
                label="Tenant ID"
                type="input"
                hint="Your Azure tenant ID"
                variant="outlined"
              ></v-text-field>
            </v-responsive>
            <v-responsive class="mx-auto py-2" max-width="500">
              <v-text-field
                clearable
                v-model="creds.intuneclientid"
                label="Client ID"
                type="input"
                hint="Your App Registrations client ID"
                variant="outlined"
              ></v-text-field>
            </v-responsive>
            <v-responsive class="mx-auto py-2" max-width="500">
              <v-text-field
                clearable
                v-model="creds.intunesecret"
                label="Client Secret"
                type="password"
                hint="The App Registrations client secret used for authentication"
                variant="outlined"
              ></v-text-field>
            </v-responsive>

            Clicking the button below will verify the above credentials and send
            the report to your email address.

            <v-spacer class="my-3"></v-spacer>
            <v-btn
              block
              class="text-none mb-4"
              size="x-large"
              @click="verifyCredentialsButton(credentials)"
              :disabled="
                !creds.intunetenantid ||
                !creds.intuneclientid ||
                !creds.intunesecret ||
                loadingButton
              "
              :loading="loadingButton"
              variant="tonal"
              v-bind:color="buttonColor"
              v-bind:text="buttonText"
            ></v-btn>
          </v-table>
        </v-card-text>
      </v-card>
      <v-spacer class="my-3"></v-spacer>
      <v-card
        color="rgb(247, 247, 247)"
        max-width="500"
        variant="elevated"
        class="mx-auto"
      >
        <v-card-title class="py-2 font-weight-black">Help</v-card-title>
        <v-card-text>
          For guidance on setting up the Azure Application Registration and
          required permissions, please follow the instructions by clicking the
          button below.
        </v-card-text>

        <v-card-text>
          <v-btn
            block
            class="text-none mb-4"
            color="indigo-darken-3"
            size="x-large"
            variant="flat"
            href="/App Registration Guide v1.2.pdf"
            target="_blank"
          >
            Download Guide
          </v-btn>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-sheet>
  <v-dialog v-model="showCompletionDialog" max-width="500" persistent>
    <div class="text-center">
      <v-card>
        <div class="py-12 text-center">
          <v-icon
            class="mb-6"
            color="success"
            icon="mdi-check-circle-outline"
            size="128"
          ></v-icon>
          <div class="text-h4 font-weight-bold">Report Requested</div>
          <div>It will take 1-2 minutes to arrive in your inbox</div>
        </div>
        <v-divider></v-divider>
        <div class="pa-4 text-center">
          <v-btn
            color="medium-emphasis"
            min-width="200"
            variant="outlined"
            @click="completionDialogBox"
          >
            Close
          </v-btn>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>
